import React, { FC } from "react";

import styles from "./progressBar.module.scss";

type ProgressBarProps = {
  currentTime: number;
  duration: number;
  onSeekChange: (value: number) => void;
  onSeekStart: () => void;
  onSeekEnd: (value: number) => void;
};

const ProgressBar: FC<ProgressBarProps> = ({
  currentTime,
  duration,
  onSeekChange,
  onSeekStart,
  onSeekEnd,
}) => {
  const progress =
    duration > 0 ? Math.min(1, Math.max(0, currentTime / duration)) : 0;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSeekChange(parseFloat(e.target.value));
  };

  const handleMouseUp = (e: React.MouseEvent<HTMLInputElement>) => {
    onSeekEnd(parseFloat((e.target as HTMLInputElement).value));
  };

  return (
    <div className={styles.track}>
      <div
        className={styles.fill}
        style={{ width: `${Math.round(progress * 100)}%` }}
      />
      <input
        type="range"
        min={0}
        max={1}
        step="0.001"
        value={progress}
        onMouseDown={onSeekStart}
        onChange={handleChange}
        onMouseUp={handleMouseUp}
        className={styles.slider}
        aria-label="Progress"
      />
    </div>
  );
};

export default ProgressBar;
